import React, { Component } from "react";
import { connect } from "react-redux";
import { TabContent, TabPane, Nav, NavLink, NavItem } from "reactstrap";
import classnames from "classnames";
import { toggle3DotMenuAction } from "../../../actions/settingsAction";
import Popup from "../../Shared/Popup";
import { createNews, getAllNews, deleteNews } from "../../api/dashboardApi";
import { getStudentProfile } from "../../api/admissionApi";
import ReactPaginate from "react-paginate";
import LinesEllipsis from "react-lines-ellipsis";
import responsiveHOC from "react-lines-ellipsis/lib/responsiveHOC";
import StudentTimeline from "./StudentTimeline";

const ResponsiveEllipsis = responsiveHOC()(LinesEllipsis);

class StudentDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 1,
      isCardRemove: false,
      isFullScreen: false,
      isCollapsed: false,
      showCreateNews: false,
      toggleMenu: false,
      newsTitle: "",
      newsDescription: "",
      newsMode: "",
      selectedNews: {},
      newsPopup: false,
    };
  }

  componentDidMount() {
    const { getAllNews } = this.props;
    getAllNews(true);

    const { getStudProfile, studentProfile : { email_id }= {} } = this.props;
    getStudProfile(email_id, {
      successCallback: (response) => console.log("Synced student profile..."),
      failureCallback: (err) => console.log("Error syncing student profile!")
    })

  }

  toggleCreateNews = () => {
    this.setState({
      showCreateNews: !this.state.showCreateNews,
      newsDescription: "",
      newsTitle: "",
      newsMode: "",
    });
  };

  toggleNewsPopup = () => {
    this.setState({ newsPopup: !this.state.newsPopup, selectedNews: {} });
  };

  openNewsPopup = (news) => {
    this.setState({ newsPopup: !this.state.newsPopup, selectedNews: news });
  };

  renderNewsNotice = () => {
    const { allNews = [], newsLoading, isDeleting } = this.props;

    return (
      <div
        className="col-xl-6 col-lg-6 col-md-12"
        style={{ minHeight: "480px" }}
      >
        <div className="card">
          <div className="card-header border-bottom">
            <h3 className="card-title">News and Notices</h3>
            {isDeleting && (
              <>
                <div className="ml-2 mr-2">Deleting...</div>
                <i className="fa fa-circle-o-notch fa-spin fa-fw"></i>
              </>
            )}
          </div>
          <div
            className="table-responsive"
            style={{
              maxHeight: "390px",
              minHeight: "200px",
              marginBottom: "2.5rem",
            }}
          >
            <table className="table card-table table-vcenter table-striped mb-0">
              <tbody>
                {!newsLoading &&
                  allNews.map((news, id) => {
                    const {
                      title,
                      description,
                      creator_name,
                      notice_created_on
                    } = news;
                    const date = new Date(notice_created_on);
                    return (
                      <tr key={id}>
                        <td className="w40">
                          <div className="avatar">
                            <img
                              className="avatar"
                              src="../assets/images/xs/avatar1.jpg"
                              alt="avatar"
                            />
                          </div>
                        </td>
                        <td style={{ paddingRight: "0px", width: "100%" }}>
                          <h6>{title}</h6>
                          <ResponsiveEllipsis text={description} maxLine={2} />
                          <div className="text-muted">{`By ${creator_name} | ${date.toDateString()}`}</div>
                        </td>
                        <td style={{ cursor: "pointer" }}>
                          <i
                            className="fa fa-eye"
                            onClick={() => this.openNewsPopup(news)}
                          ></i>
                        </td>
                      </tr>
                    );
                  })}
                {!allNews.length && !newsLoading && (
                  <tr>
                    <td>
                      <div className="empty-news">
                        <img
                          className="no-news"
                          src="../assets/images/notice.svg"
                          alt="avatar"
                        />
                        <h6>No new News and Notices</h6>
                      </div>
                    </td>
                  </tr>
                )}
                {newsLoading && (
                  <tr>
                    <td>
                      <div className="empty-news loading">
                        <h6>Fetching Notices </h6>
                        <i className="fa fa-circle-o-notch fa-spin fa-fw"></i>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div className="news-page">
            <div style={{ position: "relative" }}>
              <ReactPaginate
                breakLabel="..."
                nextLabel=">"
                previousLabel="<"
                onPageChange={(eve) => {
                  console.log("Next click", eve);
                }}
                pageRangeDisplayed={1}
                pageCount={20}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderStudentTimeline = () => {
    const {studentProfile = {}} = this.props;
    return (
      <div
        className="col-xl-6 col-lg-6 col-md-12"
        style={{ minHeight: "480px" }}
      >
        <div className="card">
          <div className="card-header border-bottom">
            <h3 className="card-title">Registration Timeline</h3>
          </div>
          <StudentTimeline studentProfile={studentProfile} />
        </div>
      </div>
    );
  }

  renderPopupNews = () => {
    const { selectedNews: { title = "" } = {} } = this.state;
    return (
      <Popup
        title={title}
        onCloseClick={this.toggleNewsPopup}
        content={this.renderNewsContent()}
        showClose
      />
    );
  };

  renderNewsContent = () => {
    const {
      selectedNews: { description = "", creator_name, notice_created_on } = {},
    } = this.state;
    const date = new Date(notice_created_on);
    return (
      <div className="p-3">
        {description}
        <div className="text-muted mt-2">{`By ${creator_name} | ${date.toDateString()}`}</div>
      </div>
    );
  };

  renderDashboard = () => {
    return (
      <TabPane tabId={1} className={classnames(["fade show"])}>
        <div className="row clearfix row-deck">
          {this.renderNewsNotice()}
          {this.renderStudentTimeline()}
        </div>
      </TabPane>
    );
  };

  createUserNews = () => {
    const { newsDescription, newsTitle, newsMode } = this.state;
    const { id, createNews, fullName = "" } = this.props;
    createNews(
      { newsDescription, newsTitle, id, newsMode, fullName },
      this.createNewsCallback
    );
  };

  createNewsCallback = () => {
    const { getAllNews } = this.props;
    this.toggleCreateNews();
    getAllNews();
  };

  renderContent = () => {
    const { newsTitle = "", newsDescription = "", newsMode } = this.state;
    const { isCreating } = this.props;
    const newsModes = [
      { code: "select", value: "--Select--" },
      { code: "student", value: "Student" },
      { code: "faculty", value: "Faculty" },
      { code: "all_classes", value: "All Classes" },
      { code: "website", value: "Website" },
    ];
    return (
      <div className="popup-content">
        <div className="form-group">
          <label htmlFor="Title">News Title</label>
          <input
            type="text"
            className="form-control"
            id="Title"
            onChange={(e) => this.setState({ newsTitle: e.target.value })}
            value={newsTitle}
          />
        </div>
        <div className="form-group">
          <label>News Mode</label>
          <select
            className="form-control"
            onChange={(e) => this.setState({ newsMode: e.target.value })}
            value={newsMode}
          >
            {newsModes.map((mode, i) => {
              return (
                <option value={mode.code} key={i}>
                  {mode.value}
                </option>
              );
            })}
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="description">Description</label>
          <textarea
            className="form-control"
            id="description"
            rows="8"
            onChange={(e) => {
              this.setState({ newsDescription: e.target.value });
            }}
            value={newsDescription}
          ></textarea>
        </div>
        <div className="button-section pt-2">
          <button
            type="button"
            className="btn btn-secondary mr-3"
            onClick={this.toggleCreateNews}
          >
            Discard
          </button>
          <button
            type="button"
            className="btn btn-info mr-3"
            disabled={
              !newsTitle ||
              !newsDescription ||
              !newsMode ||
              newsMode === newsModes[0].code ||
              isCreating
            }
            onClick={this.createUserNews}
          >
            {isCreating ? (
              <i className="fa fa-circle-o-notch fa-spin fa-fw"></i>
            ) : (
              "Create"
            )}
          </button>
        </div>
      </div>
    );
  };

  renderCreateNews = () => {
    return (
      <Popup
        title="Create News"
        onCloseClick={this.toggleCreateNews}
        content={this.renderContent()}
      />
    );
  };

  render() {
    const { activeTab, newsPopup } = this.state;
    return (
      <>
        <div className="section-body">
          <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center">
              <div className="header-action">
                <h1 className="page-title">Student Dashboard</h1>
                <ol className="breadcrumb page-breadcrumb">
                  <li className="breadcrumb-item">
                    <span>St. Andrews College</span>
                  </li>
                  <li className="breadcrumb-item">
                    <span>University</span>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Student Dashboard
                  </li>
                </ol>
              </div>
              <Nav tabs className="page-header-tab">
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === 1 })}
                    onClick={() => this.setState({ activeTab: 1 })}
                  >
                    Dashboard
                  </NavLink>
                </NavItem>
              </Nav>
            </div>
          </div>
        </div>
        <div className="section-body mt-4">
          <div className="container-fluid">
            <TabContent activeTab={activeTab}>
              {this.renderDashboard()}
            </TabContent>
          </div>
        </div>
        {this.state.showCreateNews && this.renderCreateNews()}
        {newsPopup && this.renderPopupNews()}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  is3DotMenu: state.settings.is3DotMenu,
  allNews: state.dashboardReducer.allNews,
  id: state.authenticationReducer._id,
  newsLoading: state.dashboardReducer.newsLoading,
  isDeleting: state.dashboardReducer.isDeleting,
  isCreating: state.dashboardReducer.isCreating,
  fullName: state.authenticationReducer.userProfile.full_name,
  studentProfile: state.authenticationReducer.studentProfile
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  toggle3DotMenuAction: (e) => dispatch(toggle3DotMenuAction(e)),
  getAllNews: (e) => dispatch(getAllNews(e)),
  deleteNews: (e, cb) => dispatch(deleteNews(e, cb)),
  createNews: (e, cb) => dispatch(createNews(e, cb)),
  getStudProfile: (email, cbs) => dispatch(getStudentProfile(email, cbs))
});
export default connect(mapStateToProps, mapDispatchToProps)(StudentDashboard);
